import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccGoalComment } from '@interfaces';
import { GoalDetailsDialogDataService } from '../../goal-details-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService, dialogDataService: GoalDetailsDialogDataService): GridSetup<AccGoalComment> {

	return {
		rowName: { singular: 'Comment', plural: 'Comments' },
		getRowKey: row => '' + row.accGoalCommentId,
		stateKey: 'acc-goal-comments-grid',
		actions: getActions(dialog, dialogDataService),
		buttons: getButtons(dialog, dialogDataService),
		columns: getColumns(util),
	}
}
